import Tabs from './Tabs';
import Tab from './Tab';

export { Tabs, Tab };



// WEBPACK FOOTER //
// ./src/components/Tabs/index.ts